import { API_AUTH } from "./common";

const GiaHanNoPhaiThuApi = {
  add: (
    dataSubmit = {
      ChoVayID: "",
      Time: "",
      Note: "",
      Value: "",
      TimeMustPay: "",
    }
  ) => API_AUTH.post(`nophaithu/luu-ghi-chu-cho-vay`, dataSubmit),
  delete: (choVayNoteId) =>
    API_AUTH.post(
      `nophaithu/xoa-ghi-chu-cho-vay?choVayNoteId=${choVayNoteId}`,
      {}
    ),
};

export default GiaHanNoPhaiThuApi;
